module.exports = __webpack_public_path__ + "img/banner.3d0d2abf.png";